import { BaseService } from '../../infra/base.service'
import type { GetGoogleTokenDto } from './dto/get-google-token.dto'
import type { Integration } from './integration'
import type { IntegrationRepository } from './integration.repository'

export class IntegrationService extends BaseService<Integration> {
    constructor(private rep: IntegrationRepository) {
        super(rep)
    }

    async findFromUserAndCompany() {
        return await this.rep.getAll({})
    }

    async getGoogleRefreshToken(dto: GetGoogleTokenDto) {
        return this.rep.getGoogleRefreshToken(dto)
    }

    async getIntegrationCalendars(integrationId: string) {
        return this.rep.getIntegrationCalendars(integrationId)
    }
}
